import type { EmployerUserInvitationConflict } from './types';

export const INVITE_ALREADY_MEMBER_MESSAGE =
  'This email address is already linked to a member of this organization. Ask your administrator to invite a different email address.';

// Shared by the invitation landing page (shown before Accept) and the accept
// page (shown when the API still answers 409), so both say the same thing.
export const INVITE_CONFLICT_MESSAGES: Record<EmployerUserInvitationConflict, string> = {
  provider_account:
    "This email belongs to a MedCredVault provider account, so it can't join an employer organization. Ask your administrator to invite a different email address.",
  other_org:
    'This account already belongs to another employer organization. Ask your administrator to invite a different email address.',
  // [MCV-1796] The third eligibility conflict: the invited address is already a member here.
  already_member: INVITE_ALREADY_MEMBER_MESSAGE,
};
